import { ModalComponents } from './enums';

export type TypedObject = { [key: string]: any };
export type StringObject = { [key: string]: string };

export type Token = {
  originalValue: string;
  exp: number;
  iat: number;
};

export type ModalState = {
  active: boolean;
  component: ModalComponents;
  props: any;
}

export type AlertState = {
  active: boolean;
  text: string;
  type: string;
}

export * from './enums';
export * from './datatypes';
export * from './interfaces';